import React from "react";
import { connect } from "react-redux";

import history from '../../history'

import "./userHome.css";
import CampaignSearch from "../campaign/CampaignSearch";
import CampaignResult from "../campaign/CampaignResult";
import LogSearch from "../logs/LogSearch";
import LogResult from "../logs/LogResult";
import ColdSmtpSearch from "../coldSmtp/ColdSmtpSearch";
import ColdSmtpResult from "../coldSmtp/ColdSmtpResult";


export class UserHome extends React.Component {



  handleFailure = (result) => {
    alert(result)
  }
  handleLogin = (googleData) => {
    console.log(googleData)
    this.props.logIn(googleData.tokenId, googleData.accessToken)
      .then((response) => {
        if (response === 'success') {
          history.push('/')
        }
      })

  }

  renderContent() {
    console.log(this.props.match);
    switch (this.props.selectedMenuSection) {

      case 'header-menu-logs':
        return (
          <>
            <LogSearch
              logTerm={this.props.match.params.logTerm}
              logType={this.props.match.params.logType}
            />
            <LogResult />
          </>
        );
      case 'header-menu-coldsmtp':
        return (
          <>
            <ColdSmtpSearch
              searchTerm={ this.props.match.path.includes("/coldSmtp") ? this.props.match.params.term : ''}
            />
            <ColdSmtpResult />
          </>
        );

      case 'header-menu-campaign':
      default:
        return (
          <>
            <CampaignSearch searchTerm={this.props.match.path.includes("/campaign") ? this.props.match.params.term : ''} />
            <CampaignResult />
          </>
        );
    }
  }

  render() {
    return <div className="UserHome">{this.renderContent()}</div>;
  }

}


const mapStateToProps = (state) => {
  return { auth: state.auth, selectedMenuSection: state.selectedMenuSection };
};

export default connect(mapStateToProps)(UserHome);
